import {
  ESTADO_VENCIDA,
  ESTADOS_FINANCIEROS,
} from '../../utils/cuentasPorPagar'

function EstadoFinancieroBadge({ fila }) {
  const estado = ESTADOS_FINANCIEROS[fila.estado]

  return (
    <div className="flex flex-wrap gap-1.5">
      <span
        className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${estado.clase}`}
      >
        {estado.etiqueta}
      </span>

      {fila.vencida && (
        <span
          className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${ESTADO_VENCIDA.clase}`}
        >
          {ESTADO_VENCIDA.etiqueta}
        </span>
      )}

      {fila.requiereConciliacionFactura && (
        <span
          title="El monto de la factura no coincide con el total de las compras asociadas."
          className="inline-flex items-center rounded-full bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700"
        >
          Conciliar factura
        </span>
      )}

      {!fila.vencida && fila.vencimientoSuperado && (
        <span
          title="La fecha de vencimiento ya pasó, pero la compra aún no tiene una deuda confirmada."
          className="inline-flex items-center rounded-full bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-600"
        >
          Vencimiento superado
        </span>
      )}
    </div>
  )
}

export default EstadoFinancieroBadge
